type NavigationRangeHookProps = {
  selectedIndex: number
  nItems: number
  onIndexChange: (newIndex: number, direction: 'previous' | 'next') => void
}

export const useNavigationRange = ({
  selectedIndex,
  nItems,
  onIndexChange,
}: NavigationRangeHookProps) => {
  const indexStartingAt1 = selectedIndex + 1

  const canGoBack = selectedIndex > 0

  const canGoForward = selectedIndex < nItems - 1

  const handlePrevious = () => {
    if (!canGoBack) return
    onIndexChange(selectedIndex - 1, 'previous')
  }

  const handleNext = () => {
    if (!canGoForward) return
    onIndexChange(selectedIndex + 1, 'next')
  }

  return {
    indexStartingAt1,
    canGoBack,
    canGoForward,
    handlePrevious,
    handleNext,
    shouldShowNavigation: nItems > 1,
  }
}
